import { logIn, refreshToken, getData } from "../../api/api";
import router from "../../router/routes";

const state = {
  loggedIn: false,
  token: null,
  tokenRenewedTime: false,
  loading: false,
  error: false,
  alert: true,
  validationAlerts: [],
  errorAlerts: [],
};

// getters
const getters = {
  // return the session token
  token: state => {
    return state.token;
  },
  tokenRenewedTime: state => {
    return state.tokenRenewedTime;
  },
  // return whether user is logged in
  loggedIn: state => {
    return state.loggedIn;
  },
  // return whether something is loading
  loading: state => {
    return state.loading;
  },
  // return whether there's an error with logging in
  error: state => {
    return state.error;
  },
  // return whether alert bar should be open
  alert: state => {
    return state.alert;
  },
  // return array of validation errors to be shown in alert banner
  validationAlerts: state => {
    return state.validationAlerts;
  },
  // return list of errorAlerts
  errorAlerts: state => {
    return state.errorAlerts;
  }
};

// actions
const actions = {
  closeAlert({ commit }) {
    commit("setAlert", false);
  },
  logUserIn({ commit, dispatch }, payload) {
    commit("loadingStart");
    commit("errorFalse");
    return logIn(payload.email, payload.password)
      .then(result => {
        commit("loadingEnd");
        commit("setLoggedIn");
        dispatch("setData", result);
        return result;
      })
      .catch(error => {
        commit("errorTrue");
        throw error;
      });
  },
  // clears user session and redirects user to login screen
  logOut({ dispatch }) {
    router.push({ name: "login" });
    dispatch("clearSession");
  },
  // gets a new token for user
  getNewToken({ dispatch, state }) {
    return refreshToken(state.token).then(result =>
      dispatch("setToken", result.data.dashboardToken)
    );
  },
  // clears token and data, marks user as logged out
  clearSession({ commit }) {
    // clear dashboard token
    commit("setToken", null);
    // clear token renewed time
    commit("clearTokenRenewedTime");
    // clear account data
    commit("account/setData", {}, { root: true });
    commit("setLoggedOut");
  },
  setData({ commit }, payload) {
    // store dashboard token
    commit("setToken", payload.data.dashboardToken);
    // store timers (widgets) only in timer module
    const timers = [...payload.data.account.widgetDtos];
    delete payload.data.account.widgetDtos;
    commit("timers/setTimers", timers, { root: true });
    // set account data in vuex account store
    commit("account/setData", payload.data.account, { root: true });
  },
  setToken({ commit }, payload) {
    commit("setToken", payload);
    // set time for when new token was acquired
    commit("setTokenRenewedTime");
  },
};

// mutations
const mutations = {
  setAlert(state, payload) {
    state.alert = payload;
  },
  setToken(state, payload) {
    state.token = payload;
  },
  setTokenRenewedTime(state) {
    state.tokenRenewedTime = new Date().getTime();
  },
  clearTokenRenewedTime(state) {
    state.tokenRenewedTime = false;
  },
  removeToken(state) {
    state.token = "";
  },
  setLoggedIn(state) {
    state.loggedIn = true;
  },
  setLoggedOut(state) {
    state.loggedIn = false;
  },
  loadingStart(state) {
    state.loading = true;
  },
  loadingEnd(state) {
    state.loading = false;
  },
  errorTrue(state) {
    state.error = true;
  },
  errorFalse(state) {
    state.error = false;
  },
  addValidationAlert(state, validationInfo) {
    state.validationAlerts.push(validationInfo);
  },
  clearValidationAlerts(state) {
    state.validationAlerts = [];
  },
  addErrorAlert(state, alert) {
    state.errorAlerts.push(alert);
  },
  closeErrorAlert(state, alertIndex) {
    state.errorAlerts.splice(alertIndex, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
